"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dim = void 0;
const dim = (text) => text;
exports.dim = dim;
